<template>
  <a-layout class='index animated fadeIn'>
    <a-spin :spinning="listLoading">
      <a-card :bordered='false'>
        <div>
          <p>提示：数据为0是微信接口未返回数据，请稍后再刷新或到公众号后台查看</p>
          <div class="s_flex_bian_c m-b-60 m-t-25 s_bf7 height-125">
            <div class="width25">
              <p class="fz-24 s_c333 text-ac">{{data.yesterday.new_user}}</p>
              <p class="s_c666 p-t-5 s_flex_center">昨日新关注人数</p>
            </div>
            <div class="width25 s_bor_l_cd9">
              <p class="fz-24 s_c333 text-ac">{{data.yesterday.cancel_user}}</p>
              <p class="s_c666 p-t-5 s_flex_center">昨日取消关注人数</p>
            </div>
            <div class="width25 s_bor_l_cd9">
              <p class="fz-24 s_c333 text-ac">{{data.yesterday.net_increase}}</p>
              <p class="s_c666 p-t-5 s_flex_center">
                昨日净增关注人数
                <a-tooltip>
                  <template #title>
                    提示：昨日净增关注人数=昨日新关注人数-昨日取消关注人数。
                  </template>
                  <QuestionCircleOutlined class="s_c376 m-l-5" />
                </a-tooltip>
              </p>
            </div>
            <div class="width25 s_bor_l_cd9">
              <p class="fz-24 text-ac" style="color: #ffaa33;">{{data.total_user}}</p>
              <p class="s_c666 p-t-5 s_flex_center">
                关注总数
                <a-tooltip>
                  <template #title>
                    提示：统计截止至昨日的粉丝总数，不包含当日数据。
                  </template>
                  <QuestionCircleOutlined class="s_c376 m-l-5" />
                </a-tooltip>
              </p>
            </div>
          </div>
        </div>
        <div class="s_flex_bian_c ">
          <p class="s_c333">七天粉丝增长趋势<span class="s_c999 fz-12">（{{data.before_week_date}}）</span></p>
          <!-- <a-button type="link">更多></a-button> -->
        </div>
        <echart :echartsData='dayFans' :key="1" v-if="show"></echart>
        <div class="s_flex_bian_c m-t-40">
          <p class="s_c333">七天消息发送趋势<span class="s_c999 fz-12">（{{data.before_week_date}}）</span></p>
          <!-- <a-button type="link">更多></a-button> -->
        </div>
        <echart :echartsData='dayMsg' :key="2" v-if="show"></echart>
      </a-card>
    </a-spin>
  </a-layout>
</template>
<script>
  import { QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { onMounted, reactive, toRefs } from "vue";
  import { getWx_statistics } from '@/api/public_wx';
  import echart from './echart/index';
  import { iscode } from '../../utils/app';
  import { message } from "ant-design-vue";
  export default {
    components: { echart, QuestionCircleOutlined },
    setup() {
      const state = reactive({
        dayFans: {
          date: [],
          dataName: ['新增关注人数', '取消关注人数', '净增关注人数'],
          data1: [],
          data2: [],
          data3: []
        },
        dayMsg: {
          date: [],
          dataName: ['消息发送人数', '消息发送次数', '人均发送次数'],
          data1: [],
          data2: [],
          data3: []
        },
        listLoading: true,
        show: false,
        data: { yesterday: {} }
      });
      const initData = async () => {
        let result = await getWx_statistics().then(res => res.data).catch(error => error)
        state.listLoading = false
        if (iscode(result)) {
          state.data = result.data
          result.data.msg_statistics_data.forEach(element => {
            state.dayMsg.date.push(element.ref_date)
            state.dayMsg.data1.push(element.msg_user)
            state.dayMsg.data2.push(element.msg_count)
            state.dayMsg.data3.push(element.send_average)
          });
          result.data.user_statistics.forEach(element => {
            state.dayFans.date.push(element.ref_date)
            state.dayFans.data1.push(element.new_user)
            state.dayFans.data2.push(element.cancel_user)
            state.dayFans.data3.push(element.net_increase)
          });
        }else{
          message.error(result.msg);
        }
        state.show = true
      }
      onMounted(() => {
        initData()
      });
      return {
        ...toRefs(state)
      };
    },
  };
</script>